import React from 'react';
import styles from './BankOptionTransformer.module.css';

interface BankOptionTransformerProps {
    name: string;
    logoUrl: string;
}

const BankOptionTransformer = ({
    name,
    logoUrl
}: BankOptionTransformerProps) => {
    return (
        <div className={styles.contentContainer}>
            <img className={styles.logoImage}
                src={logoUrl}
                alt={name}
            />
            <span>{name}</span>
        </div>
    );
}

export default BankOptionTransformer;
